export enum Colors {
  cobuTurquoise = '#16BBD2',
  cobuRed = '#EC1659',
  cobuPurple = '#A031E4',
  cobuDarkBlue = '#272163',
  cobuYellow = '#FEC100',
  cobuTextBlack = '#262626'
}
